"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceIdTableT = exports.DeviceIdTable = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const device_id_js_1 = require("../../solarxr-protocol/datatypes/device-id.js");
/**
 * To be used inside unions
 */
class DeviceIdTable {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsDeviceIdTable(bb, obj) {
        return (obj || new DeviceIdTable()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsDeviceIdTable(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new DeviceIdTable()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new device_id_js_1.DeviceId()).__init(this.bb_pos + offset, this.bb) : null;
    }
    static startDeviceIdTable(builder) {
        builder.startObject(1);
    }
    static addId(builder, idOffset) {
        builder.addFieldStruct(0, idOffset, 0);
    }
    static endDeviceIdTable(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createDeviceIdTable(builder, idOffset) {
        DeviceIdTable.startDeviceIdTable(builder);
        DeviceIdTable.addId(builder, idOffset);
        return DeviceIdTable.endDeviceIdTable(builder);
    }
    unpack() {
        return new DeviceIdTableT((this.id() !== null ? this.id().unpack() : null));
    }
    unpackTo(_o) {
        _o.id = (this.id() !== null ? this.id().unpack() : null);
    }
}
exports.DeviceIdTable = DeviceIdTable;
class DeviceIdTableT {
    constructor(id = null) {
        this.id = id;
    }
    pack(builder) {
        return DeviceIdTable.createDeviceIdTable(builder, (this.id !== null ? this.id.pack(builder) : 0));
    }
}
exports.DeviceIdTableT = DeviceIdTableT;
